// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CloudTwoToneSvg from "@fishx/icons-svg/es/asn/CloudTwoTone";
import FishxIcon from '../components/FishxIcon';

var CloudTwoTone = function CloudTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CloudTwoToneSvg
  }));
};

CloudTwoTone.displayName = 'CloudTwoTone';
export default React.forwardRef(CloudTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CloudTwoTone.js
// module id = 2253
// module chunks = 0